export { UISkeleton } from './UISkeleton';
export type { UISkeletonProps } from './UISkeleton';
